export const SYMBOL = 1;
export const NUMBER = 2;
export const LIST = 3;
export const BANG = "bang";
